import React from 'react';
import { Formik } from 'formik';
import ErrorBoundary from 'components/common/ErrorBoundary';
import AddPaymentForm from './components/AddPaymentForm';

const initialValues = {
  buyer: '',
  order_number: '',
  amount: '',
  utr: '',
};

const AddPayment = () => {
  const handleSubmit = () => {};
  return (
    <div>
      <ErrorBoundary>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          children={(props) => {
            return <AddPaymentForm {...props} />;
          }}
        />
      </ErrorBoundary>
    </div>
  );
};

export default AddPayment;
